export default "<div class=\"eE\"><ion-list class=\"eH\">\n   <p>Please enter an amount between <br> {{min}} - {{max}}</p>\n</ion-list></div>"